module.exports = __webpack_public_path__ + "media/Planning_0.0_to_2.0.02f78b10.mp4";